// Design Ref: §2.1 — Infrastructure 레이어. 순수 HTTP 클라이언트
// 책임: credentials 자동 부착 + 401 시 session.refresh 위임. 토큰 저장/조회 지식 없음

import { browser } from '$app/environment';
import { API_BASE_URL } from '$lib/config/api.js';
import * as session from '$lib/auth/session.js';

export async function apiRequest(url, options = {}) {
	if (!browser) return null;

	const defaultHeaders = {};
	// FormData일 경우 Content-Type을 설정하지 않음 (브라우저가 boundary 자동 설정)
	if (!(options.body instanceof FormData)) {
		defaultHeaders['Content-Type'] = 'application/json';
	}

	const config = {
		credentials: 'include', // Plan FR-02 — 모든 보호 호출에 쿠키 자동 송신
		...options,
		headers: {
			...defaultHeaders,
			...options.headers
		}
	};
	// 호출자가 credentials를 override해도 쿠키 인증 누락 위험을 막기 위해 강제
	config.credentials = 'include';

	try {
		let response = await fetch(`${API_BASE_URL}${url}`, config);

		// Plan FR-03 — 401 시 session.refresh로 위임 (대기 큐 관리는 session 내부)
		if (response.status === 401) {
			const ok = await session.refresh();
			if (ok) {
				response = await fetch(`${API_BASE_URL}${url}`, config);
			} else {
				// refresh 실패: 로그아웃 + 로그인 페이지로
				await session.logout({ redirect: true });
				return { ok: false, status: 401, data: null };
			}
		}

		const data = await response.json().catch(() => null);
		return { ok: response.ok, status: response.status, data };
	} catch (error) {
		return { ok: false, status: 0, data: null, error };
	}
}

// 편의 메서드
export const api = {
	get: (url, options = {}) => apiRequest(url, { ...options, method: 'GET' }),
	post: (url, body, options = {}) =>
		apiRequest(url, { ...options, method: 'POST', body: JSON.stringify(body) }),
	put: (url, body, options = {}) =>
		apiRequest(url, { ...options, method: 'PUT', body: JSON.stringify(body) }),
	patch: (url, body, options = {}) =>
		apiRequest(url, { ...options, method: 'PATCH', body: JSON.stringify(body) }),
	delete: (url, options = {}) => apiRequest(url, { ...options, method: 'DELETE' })
};
